import { render } from "./OfferPage.vue?vue&type=template&id=f72f6fbe&scoped=true"
import script from "./OfferPage.vue?vue&type=script&lang=js"
export * from "./OfferPage.vue?vue&type=script&lang=js"

import "./OfferPage.vue?vue&type=style&index=0&id=f72f6fbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f72f6fbe"]])

export default __exports__